/* ==========================================================================
   Noppa - Ella tipi tema | tema betigi (bagimsiz vanilla JS)
   ========================================================================== */
(function () {
  'use strict';

  var T = (window.NPTheme = window.NPTheme || {});
  T.settings = T.settings || {};
  T.strings = T.strings || {};
  T.routes = T.routes || {};

  /* ------------------------------------------------------------ yardimcilar */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt || false); }
  function debounce(fn, wait) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  T.qs = qs; T.qsa = qsa; T.on = on;

  /* ------------------------------------------------------------ para birimi */
  function formatMoney(cents, format) {
    /* Tema bicimi: 1.500 TL / 1.363,64 TL — kurus sifirsa yazilmaz. Liquid'deki
       snippets/np-money.liquid ile ayni sonucu uretir. */
    if (!format && (T.settings.moneyStyle || 'tema') !== 'shopify') {
      var tv = Math.round(Number(cents) || 0);
      var tneg = tv < 0;
      if (tneg) tv = -tv;
      var lira = Math.floor(tv / 100);
      var kurus = tv % 100;
      var out = String(lira).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      if (kurus > 0) out += ',' + (kurus < 10 ? '0' + kurus : String(kurus));
      return (tneg ? '-' : '') + out + ' ' + (T.settings.moneySymbol || 'TL');
    }
    var fmt = format || T.settings.moneyFormat || '{{amount_with_comma_separator}} TL';
    var value = Number(cents) || 0;
    function num(v, precision, thousand, decimal) {
      v = (v / 100).toFixed(precision);
      var parts = v.split('.');
      var ip = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousand);
      return precision ? ip + decimal + parts[1] : ip;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case 'amount': return num(value, 2, ',', '.');
        case 'amount_no_decimals': return num(value, 0, ',', '.');
        case 'amount_with_comma_separator': return num(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(value, 0, '.', ',');
        case 'amount_with_space_separator': return num(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(value, 0, ' ', ',');
        case 'amount_with_apostrophe_separator': return num(value, 2, "'", '.');
        default: return num(value, 2, '.', ',');
      }
    });
  }
  T.formatMoney = formatMoney;

  /* ------------------------------------------------------------ overlay / drawer */
  var Drawer = {
    open: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      qsa('.np-drawer.is-open').forEach(function (d) { if (d !== el) d.classList.remove('is-open'); });
      document.dispatchEvent(new CustomEvent('np:overlay:open'));
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      var ov = qs('#np-overlay');
      if (ov) ov.classList.add('is-open');
      document.body.classList.add('np-no-scroll');
      var focusable = qs('input,button,a', el);
      if (focusable) setTimeout(function () { try { focusable.focus(); } catch (e) {} }, 260);
    },
    close: function () {
      qsa('.np-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
      qsa('.np-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); m.setAttribute('aria-hidden', 'true'); });
      var ov = qs('#np-overlay');
      if (ov) ov.classList.remove('is-open');
      document.body.classList.remove('np-no-scroll');
      document.dispatchEvent(new CustomEvent('np:overlay:close'));
    }
  };
  T.Drawer = Drawer;

  var Modal = {
    open: function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      var ov = qs('#np-overlay');
      if (ov) ov.classList.add('is-open');
      document.body.classList.add('np-no-scroll');
    },
    close: Drawer.close
  };
  T.Modal = Modal;

  function bindDrawerTriggers() {
    on(document, 'click', function (e) {
      var openBtn = e.target.closest('[data-np-drawer-open]');
      if (openBtn) { e.preventDefault(); Drawer.open(openBtn.getAttribute('data-np-drawer-open')); return; }
      var modalBtn = e.target.closest('[data-np-modal-open]');
      if (modalBtn) { e.preventDefault(); Modal.open(modalBtn.getAttribute('data-np-modal-open')); return; }
      if (e.target.closest('[data-np-close]') || e.target.id === 'np-overlay') { e.preventDefault(); Drawer.close(); }
    });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') Drawer.close(); });
  }

  /* ------------------------------------------------------------ bildirim */
  var toastTimer;
  function toast(html) {
    var el = qs('#np-toast');
    if (!el) return;
    el.innerHTML = html;
    el.classList.add('is-open');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-open'); }, 4200);
  }
  T.toast = toast;

  /* ------------------------------------------------------------ sepet */
  var Cart = {
    data: null,
    get: function () {
      return fetch(T.routes.cart_url + '.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { Cart.data = d; Cart.render(d); return d; });
    },
    add: function (payload, btn) {
      if (btn) btn.classList.add('is-loading');
      return fetch(T.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, body: d }; }); })
        .then(function (res) {
          if (btn) btn.classList.remove('is-loading');
          if (!res.ok) {
            toast('<div><span class="np-toast__title" style="color:var(--np-sale)">' + esc(T.strings.error || 'Hata') + '</span><span class="np-toast__name">' + esc(res.body.description || res.body.message || '') + '</span></div>');
            return null;
          }
          var item = res.body.items ? res.body.items[0] : res.body;
          toast(
            (item && item.image ? '<img src="' + esc(item.image) + '" alt="">' : '') +
            '<div><span class="np-toast__title">' + esc(T.strings.added || 'Sepete eklendi') + '</span>' +
            '<span class="np-toast__name">' + esc(item ? item.product_title || item.title : '') + '</span></div>'
          );
          return Cart.get().then(function () {
            if (T.settings.cartType === 'page') { window.location.href = T.routes.cart_url; return; }
            if (T.settings.cartType !== 'notification' && T.settings.cartOpenOnAdd !== false) Drawer.open('np-cart-drawer');
          });
        })
        .catch(function () { if (btn) btn.classList.remove('is-loading'); });
    },
    change: function (key, qty) {
      return fetch(T.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) { Cart.data = d; Cart.render(d); return d; });
    },
    render: function (cart) {
      /* rakamlar */
      qsa('[data-np-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle('np-hide', cart.item_count === 0);
      });
      qsa('[data-np-cart-total]').forEach(function (el) { el.textContent = formatMoney(cart.total_price); });

      var body = qs('[data-np-cart-lines]');
      if (!body) return;
      if (!cart.item_count) {
        body.innerHTML =
          '<div class="np-cart-empty">' +
          '<svg class="np-icon" viewBox="0 0 24 24"><circle cx="9" cy="20" r="1.6"/><circle cx="18" cy="20" r="1.6"/><path d="M1 1h3.6l2.7 12.6a2 2 0 0 0 2 1.6h8.9a2 2 0 0 0 2-1.6L22 5H6"/></svg>' +
          '<p>' + esc(T.strings.cartEmpty || 'Sepetiniz bos') + '</p>' +
          '<a class="np-btn np-btn--primary" href="' + (T.routes.all_products || '/collections/all') + '">' + esc(T.strings.continueShopping || 'Alisverise devam et') + '</a>' +
          '</div>';
      } else {
        body.innerHTML = cart.items.map(function (it) {
          var opts = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
            .map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' / ');
          return '<div class="np-cart-line" data-key="' + esc(it.key) + '">' +
            '<a class="np-cart-line__img" href="' + esc(it.url) + '">' +
            (it.image ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x$1$2')) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="np-cart-line__info">' +
            '<a class="np-cart-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            (opts ? '<div class="np-cart-line__variant">' + opts + '</div>' : '') +
            '<div class="np-price"><span class="np-price__current">' + formatMoney(it.final_price) + '</span>' +
            (it.original_price > it.final_price ? '<span class="np-price__old">' + formatMoney(it.original_price) + '</span>' : '') + '</div>' +
            '<div class="np-cart-line__bottom">' +
            '<div class="np-qty"><button type="button" data-np-line-minus aria-label="-">&minus;</button>' +
            '<input type="text" inputmode="numeric" value="' + it.quantity + '" data-np-line-qty readonly>' +
            '<button type="button" data-np-line-plus aria-label="+">+</button></div>' +
            '<button type="button" class="np-cart-line__remove" data-np-line-remove>' + esc(T.strings.remove || 'Kaldir') + '</button>' +
            '</div></div></div>';
        }).join('');
      }

      /* kargo baraji */
      var bar = qs('[data-np-shipbar]');
      if (bar) {
        var threshold = Number(bar.getAttribute('data-threshold')) || 0;
        var left = threshold - cart.total_price;
        var fill = qs('.np-shipbar__fill', bar);
        var txt = qs('.np-shipbar__text', bar);
        var pct = threshold ? Math.min(100, (cart.total_price / threshold) * 100) : 100;
        if (fill) fill.style.width = pct + '%';
        if (txt) {
          txt.innerHTML = left > 0
            ? (T.strings.shipRemaining || 'Ucretsiz kargoya <strong>{{ amount }}</strong> kaldi!')
                .replace(/\{\{\s*amount\s*\}\}/g, formatMoney(left))
                .replace('{amount}', formatMoney(left))
            : (T.strings.shipReached || 'Tebrikler! <strong>Ucretsiz kargo</strong> kazandiniz.');
        }
      }
      document.dispatchEvent(new CustomEvent('np:cart:updated', { detail: cart }));
    }
  };
  T.Cart = Cart;

  function bindCart() {
    /* urun kartindan / formdan sepete ekle */
    on(document, 'submit', function (e) {
      var form = e.target.closest('form[data-np-cart-form]');
      if (!form) return;
      e.preventDefault();
      var fd = new FormData(form);
      var payload = { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] };
      var props = {};
      fd.forEach(function (v, k) {
        var m = k.match(/^properties\[(.+)\]$/);
        if (m && v) props[m[1]] = v;
      });
      if (Object.keys(props).length) payload.items[0].properties = props;
      var sellingPlan = fd.get('selling_plan');
      if (sellingPlan) payload.items[0].selling_plan = Number(sellingPlan);
      Cart.add(payload, form.querySelector('[type=submit]'));
    });

    /* cekmece satir islemleri */
    on(document, 'click', function (e) {
      var line = e.target.closest('.np-cart-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var input = qs('[data-np-line-qty]', line);
      var qty = Number(input && input.value) || 1;
      if (e.target.closest('[data-np-line-plus]')) { e.preventDefault(); Cart.change(key, qty + 1); }
      else if (e.target.closest('[data-np-line-minus]')) { e.preventDefault(); Cart.change(key, Math.max(0, qty - 1)); }
      else if (e.target.closest('[data-np-line-remove]')) { e.preventDefault(); Cart.change(key, 0); }
    });

    /* sepet sayfasi adet degisimi */
    on(document, 'change', function (e) {
      var input = e.target.closest('[data-np-cart-qty]');
      if (!input) return;
      var key = input.getAttribute('data-key');
      Cart.change(key, Number(input.value) || 0).then(function () { window.location.reload(); });
    });
  }

  /* ------------------------------------------------------------ adet secici */
  function bindQty() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-np-qty]');
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.closest('.np-qty');
      var input = qs('input', wrap);
      if (!input) return;
      var step = btn.getAttribute('data-np-qty') === 'plus' ? 1 : -1;
      var min = Number(input.getAttribute('min') || 1);
      input.value = Math.max(min, (Number(input.value) || min) + step);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ------------------------------------------------------------ sabit header */
  function stickyHeader() {
    var sticky = qs('#np-sticky-header');
    if (!sticky) return;
    var last = 0;
    var trigger = 320;
    window.addEventListener('scroll', function () {
      var y = window.pageYOffset;
      if (y > trigger && y < last) sticky.classList.add('is-visible');
      else sticky.classList.remove('is-visible');
      last = y;
    }, { passive: true });
  }

  /* ------------------------------------------------------------ duyuru dongusu */
  function announcement() {
    var wrap = qs('[data-np-announce]');
    if (!wrap) return;
    var items = qsa('.np-topbar__msg', wrap);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, Number(wrap.getAttribute('data-interval')) || 4500);
  }

  /* ------------------------------------------------------------ mini secici */
  function miniSelects() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('.np-mini-select__btn');
      qsa('.np-mini-select.is-open').forEach(function (s) { if (!btn || s !== btn.parentNode) s.classList.remove('is-open'); });
      if (btn) { e.preventDefault(); btn.parentNode.classList.toggle('is-open'); }
    });
  }

  /* ------------------------------------------------------------ mobil menu */
  function mobileMenu() {
    on(document, 'click', function (e) {
      var t = e.target.closest('.np-mmenu__toggle');
      if (t) {
        e.preventDefault();
        t.classList.toggle('is-open');
        var sub = t.parentNode.parentNode.querySelector('.np-mmenu__sub');
        if (sub) sub.classList.toggle('is-open');
      }
      var tab = e.target.closest('.np-mmenu__tab');
      if (tab) {
        e.preventDefault();
        var root = tab.closest('[data-np-mmenu]');
        qsa('.np-mmenu__tab', root).forEach(function (x) { x.classList.remove('is-active'); });
        tab.classList.add('is-active');
        qsa('[data-np-mmenu-panel]', root).forEach(function (p) {
          p.classList.toggle('np-hide', p.getAttribute('data-np-mmenu-panel') !== tab.getAttribute('data-np-mmenu-tab'));
        });
      }
    });
  }

  /* ------------------------------------------------------------ tahmini arama */
  function predictiveSearch() {
    if (T.settings.predictive === false) return;
    qsa('[data-np-search]').forEach(function (wrap) {
      var input = qs('input[name=q]', wrap);
      var box = qs('[data-np-search-results]', wrap);
      if (!input || !box) return;
      var run = debounce(function () {
        var q = input.value.trim();
        if (q.length < 2) { box.classList.remove('is-open'); box.innerHTML = ''; return; }
        var url = (T.routes.predictive_search_url || '/search/suggest') +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=' + (T.settings.searchTypes || 'product,collection,page') +
          '&resources[limit]=' + (T.settings.searchLimit || 6) +
          '&section_id=np-predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-np-predictive-inner]');
            box.innerHTML = inner ? inner.innerHTML : '';
            box.classList.add('is-open');
          })
          .catch(function () { box.classList.remove('is-open'); });
      }, 280);
      on(input, 'input', run);
      on(input, 'focus', function () { if (box.innerHTML.trim()) box.classList.add('is-open'); });
      on(document, 'click', function (e) { if (!wrap.contains(e.target)) box.classList.remove('is-open'); });
    });
  }

  /* ------------------------------------------------------------ slideshow */
  function slideshows() {
    qsa('[data-np-slideshow]').forEach(function (root) {
      var vp = qs('.np-slideshow__viewport', root);
      var slides = qsa('.np-slideshow__slide', root);
      if (!vp || slides.length < 1) return;
      var dots = qsa('.np-slideshow__dots .np-slider__dot', root);
      var i = 0, timer = null;
      var speed = Number(root.getAttribute('data-autoplay')) || 0;

      function go(n) {
        i = (n + slides.length) % slides.length;
        vp.style.transform = 'translateX(-' + i * 100 + '%)';
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function play() { if (speed > 0 && slides.length > 1) { stop(); timer = setInterval(function () { go(i + 1); }, speed); } }
      function stop() { if (timer) clearInterval(timer); }

      on(qs('.np-slideshow__nav--next', root), 'click', function () { go(i + 1); play(); });
      on(qs('.np-slideshow__nav--prev', root), 'click', function () { go(i - 1); play(); });
      dots.forEach(function (d, k) { on(d, 'click', function () { go(k); play(); }); });
      on(root, 'mouseenter', stop);
      on(root, 'mouseleave', play);

      /* dokunmatik */
      var x0 = null;
      on(vp, 'touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      on(vp, 'touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
        x0 = null; play();
      });
      go(0); play();
    });
  }

  /* ------------------------------------------------------------ yatay kaydirici */
  function sliders() {
    qsa('[data-np-slider]').forEach(function (root) {
      var track = qs('.np-slider__track', root);
      if (!track) return;
      var prev = qs('.np-slider__nav--prev', root);
      var next = qs('.np-slider__nav--next', root);
      function step() {
        var first = track.querySelector('.np-slider__slide');
        return first ? first.getBoundingClientRect().width + 24 : 300;
      }
      function sync() {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft < 8;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      }
      on(next, 'click', function () { track.scrollLeft += step() * (window.innerWidth < 768 ? 1 : 2); });
      on(prev, 'click', function () { track.scrollLeft -= step() * (window.innerWidth < 768 ? 1 : 2); });
      on(track, 'scroll', debounce(sync, 90), { passive: true });
      sync();
    });
  }

  /* ------------------------------------------------------------ sekme & akordiyon */
  function tabs() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-np-tab]');
      if (btn) {
        e.preventDefault();
        var root = btn.closest('[data-np-tabs]');
        var id = btn.getAttribute('data-np-tab');
        qsa('[data-np-tab]', root).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        qsa('[data-np-tabpanel]', root).forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-np-tabpanel') === id);
        });
        var sl = p_findSlider(root, id);
        if (sl) sliders();
      }
      var ah = e.target.closest('.np-accordion__head');
      if (ah) {
        e.preventDefault();
        var item = ah.closest('.np-accordion__item');
        item.classList.toggle('is-open');
        ah.setAttribute('aria-expanded', item.classList.contains('is-open'));
      }
      var fh = e.target.closest('.np-facet__head');
      if (fh) {
        e.preventDefault();
        fh.closest('.np-facet').classList.toggle('is-closed');
      }
    });
  }
  function p_findSlider(root, id) { return qs('[data-np-tabpanel="' + id + '"] [data-np-slider]', root); }

  /* ------------------------------------------------------------ geri sayim */
  function countdowns() {
    var items = qsa('[data-np-countdown]');
    if (!items.length) return;
    function tick() {
      items.forEach(function (el) {
        var end = new Date(el.getAttribute('data-np-countdown')).getTime();
        if (isNaN(end)) return;
        var diff = end - Date.now();
        if (diff < 0) diff = 0;
        var d = Math.floor(diff / 864e5);
        var h = Math.floor((diff % 864e5) / 36e5);
        var m = Math.floor((diff % 36e5) / 6e4);
        var s = Math.floor((diff % 6e4) / 1000);
        var map = { days: d, hours: h, minutes: m, seconds: s };
        qsa('[data-cd]', el).forEach(function (c) {
          var v = map[c.getAttribute('data-cd')];
          c.textContent = v < 10 ? '0' + v : String(v);
        });
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------ kart hover gorseli */
  function hoverImages() {
    function yukle(card) {
      var img = qs('[data-np-hover-src]', card);
      if (!img) return;
      var src = img.getAttribute('data-np-hover-src');
      var set = img.getAttribute('data-np-hover-srcset');
      if (set) img.setAttribute('srcset', set);
      img.setAttribute('src', src);
      img.removeAttribute('data-np-hover-src');
    }
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest ? e.target.closest('.np-card') : null;
      if (card) yukle(card);
    }, { passive: true });
    document.addEventListener('focusin', function (e) {
      var card = e.target.closest ? e.target.closest('.np-card') : null;
      if (card) yukle(card);
    });
  }

  /* ------------------------------------------------------------ yukari cik */
  function toTop() {
    var btn = qs('#np-totop');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('is-visible', window.pageYOffset > 520);
    }, { passive: true });
    on(btn, 'click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ------------------------------------------------------------ yerel liste (favori/karsilastir/son bakilan) */
  function store(key) {
    try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
  }
  function saveStore(key, arr) {
    try { localStorage.setItem(key, JSON.stringify(arr.slice(0, 60))); } catch (e) {}
  }
  function syncListCounts() {
    qsa('[data-np-wishlist-count]').forEach(function (el) {
      var n = store('np_wishlist').length;
      el.textContent = n; el.classList.toggle('np-hide', n === 0);
    });
    qsa('[data-np-compare-count]').forEach(function (el) {
      var n = store('np_compare').length;
      el.textContent = n; el.classList.toggle('np-hide', n === 0);
    });
    qsa('[data-np-wishlist]').forEach(function (b) {
      b.classList.toggle('is-active', store('np_wishlist').indexOf(b.getAttribute('data-np-wishlist')) > -1);
    });
  }
  function bindLists() {
    on(document, 'click', function (e) {
      var w = e.target.closest('[data-np-wishlist]');
      if (w) {
        e.preventDefault();
        var h = w.getAttribute('data-np-wishlist');
        var list = store('np_wishlist');
        var k = list.indexOf(h);
        if (k > -1) list.splice(k, 1); else list.unshift(h);
        saveStore('np_wishlist', list);
        syncListCounts();
        document.dispatchEvent(new CustomEvent('np:list:changed', { detail: 'np_wishlist' }));
        toast('<div><span class="np-toast__title">' + esc(k > -1 ? (T.strings.wishRemoved || 'Favorilerden cikarildi') : (T.strings.wishAdded || 'Favorilere eklendi')) + '</span></div>');
      }
      var c = e.target.closest('[data-np-compare]');
      if (c) {
        e.preventDefault();
        var hh = c.getAttribute('data-np-compare');
        var cl = store('np_compare');
        if (cl.indexOf(hh) === -1) cl.unshift(hh);
        saveStore('np_compare', cl.slice(0, T.settings.compareLimit || 4));
        syncListCounts();
        toast('<div><span class="np-toast__title">' + esc(T.strings.compareAdded || 'Karsilastirmaya eklendi') + '</span></div>');
      }
    });
    syncListCounts();
  }
  function recentlyViewed() {
    if (T.settings.recentlyViewed === false) return;
    var handle = T.settings.productHandle;
    if (handle) {
      var list = store('np_recent').filter(function (h) { return h !== handle; });
      list.unshift(handle);
      saveStore('np_recent', list.slice(0, 12));
    }
    var wrap = qs('[data-np-recent]');
    if (!wrap) return;
    var handles = store('np_recent').filter(function (h) { return h !== handle; }).slice(0, 6);
    if (!handles.length) { wrap.classList.add('np-hide'); return; }
    var target = qs('[data-np-recent-track]', wrap);
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '?section_id=np-card-fragment')
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.filter(Boolean).map(function (p) {
        var doc = new DOMParser().parseFromString(p, 'text/html');
        var card = doc.querySelector('.np-card');
        return card ? '<div class="np-slider__slide" style="width:260px">' + card.outerHTML + '</div>' : '';
      }).join('');
      if (html && target) { target.innerHTML = html; wrap.classList.remove('np-hide'); sliders(); syncListCounts(); observeAnim(); }
      else wrap.classList.add('np-hide');
    });
  }

  /* ------------------------------------------------------------ hizli bakis */
  function quickView() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-np-quickview]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-np-quickview');
      var modal = qs('#np-quickview');
      if (!modal) return;
      var box = qs('[data-np-quickview-body]', modal);
      box.innerHTML = '<div class="np-quickview__loading"><span class="np-spinner" style="border-color:#ddd;border-top-color:var(--np-primary);margin:0 auto"></span></div>';
      Modal.open('np-quickview');
      fetch('/products/' + handle + '?section_id=np-quick-view')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-np-quickview-inner]');
          box.innerHTML = inner ? inner.innerHTML : html;
          initVariantPickers(box);
        })
        .catch(function () { box.innerHTML = '<div class="np-quickview__loading">' + esc(T.strings.error || 'Hata') + '</div>'; });
    });
  }

  /* ------------------------------------------------------------ varyant secici */
  function initVariantPickers(root) {
    qsa('[data-np-variants]', root || document).forEach(function (wrap) {
      if (wrap.dataset.npBound === '1') return;
      wrap.dataset.npBound = '1';
      var dataEl = qs('[data-np-variant-json]', wrap);
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var modal = wrap.closest('#np-quickview');
      function targetForms() {
        if (modal) return qsa('form[data-np-cart-form]', modal);
        var scoped = qsa('form[data-np-product-scope="main"]');
        if (scoped.length) return scoped;
        var host = wrap.closest('.np-pinfo, .np-fproduct, .np-quickview') || document;
        return qsa('form[data-np-cart-form]', host);
      }
      function targetPrices() {
        if (modal) return qsa('[data-np-price]', modal);
        var scoped = qsa('[data-np-price-scope="main"] [data-np-price]');
        if (scoped.length) return scoped;
        var host = wrap.closest('.np-pinfo, .np-fproduct, .np-quickview') || document;
        return qsa('[data-np-price]', host);
      }

      function selected() {
        return qsa('[data-np-option]', wrap).map(function (g) {
          var a = qs('.is-active', g);
          return a ? a.getAttribute('data-value') : null;
        });
      }
      function update() {
        var sel = selected();
        var match = variants.find(function (v) {
          return sel.every(function (s, i) { return s === null || v.options[i] === s; });
        });
        var forms = targetForms();
        var prices = targetPrices();

        if (match) {
          forms.forEach(function (f) {
            var i = qs('input[name=id]', f);
            if (i) i.value = match.id;
            var sub = qs('[type=submit]', f);
            if (sub) {
              sub.disabled = !match.available;
              var t = qs('.np-btn__text', sub);
              if (t) t.textContent = match.available ? (T.strings.addToCart || 'Sepete ekle') : (T.strings.soldOut || 'Tukendi');
            }
          });
          prices.forEach(function (priceEl) {
            priceEl.innerHTML =
              '<span class="np-price__current">' + formatMoney(match.price) + '</span>' +
              (match.compare_at_price > match.price ? '<span class="np-price__old">' + formatMoney(match.compare_at_price) + '</span>' : '');
            priceEl.classList.toggle('np-price--on-sale', match.compare_at_price > match.price);
          });
          if (match.featured_image && match.featured_image.src) selectGalleryBySrc(match.featured_image.src);
          if (match.id && window.history.replaceState && T.settings.template === 'product') {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', u.toString());
          }
        } else {
          targetForms().forEach(function (f) {
            var sub = qs('[type=submit]', f);
            if (!sub) return;
            sub.disabled = true;
            var t2 = qs('.np-btn__text', sub);
            if (t2) t2.textContent = T.strings.unavailable || 'Secim mevcut degil';
          });
        }
        /* olmayan kombinasyonlari isaretle */
        qsa('[data-np-option]', wrap).forEach(function (g, gi) {
          qsa('[data-value]', g).forEach(function (btn) {
            var test = selected();
            test[gi] = btn.getAttribute('data-value');
            var ok = variants.some(function (v) {
              return test.every(function (s, i) { return s === null || v.options[i] === s; }) && v.available;
            });
            btn.classList.toggle('is-unavailable', !ok);
          });
        });
      }

      qsa('[data-np-option]', wrap).forEach(function (g) {
        on(g, 'click', function (e) {
          var btn = e.target.closest('[data-value]');
          if (!btn) return;
          e.preventDefault();
          qsa('[data-value]', g).forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var lbl = qs('[data-np-option-selected]', g.closest('.np-option'));
          if (lbl) lbl.textContent = btn.getAttribute('data-value');
          update();
        });
      });
      update();
    });
  }
  T.initVariantPickers = initVariantPickers;

  function selectGalleryBySrc(src) {
    var key = String(src).split('?')[0].split('/').pop().split('.')[0];
    var thumb = qsa('[data-np-gallery-thumb]').find(function (t) {
      return (t.getAttribute('data-src') || '').indexOf(key) > -1;
    });
    if (thumb) thumb.click();
  }

  /* ------------------------------------------------------------ urun galerisi */
  function gallery() {
    var root = qs('[data-np-gallery]');
    if (!root) return;
    var main = qs('[data-np-gallery-main]', root);
    var img = qs('img', main);
    var thumbs = qsa('[data-np-gallery-thumb]', root);
    var idx = 0;

    function show(n) {
      if (!thumbs.length) return;
      idx = (n + thumbs.length) % thumbs.length;
      var t = thumbs[idx];
      img.src = t.getAttribute('data-src');
      img.srcset = '';
      img.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
    }
    thumbs.forEach(function (t, k) { on(t, 'click', function () { show(k); }); });
    on(qs('[data-np-gallery-next]', root), 'click', function () { show(idx + 1); });
    on(qs('[data-np-gallery-prev]', root), 'click', function () { show(idx - 1); });
    on(qs('[data-np-gallery-zoom]', root), 'click', function () { main.classList.toggle('is-zoom'); });
    on(main, 'mousemove', function (e) {
      if (!main.classList.contains('is-zoom')) return;
      var r = main.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
    });
    on(main, 'mouseleave', function () { main.classList.remove('is-zoom'); });
    if (thumbs.length) thumbs[0].classList.add('is-active');
  }

  /* ------------------------------------------------------------ sabit sepete ekle */
  function stickyAtc() {
    var bar = qs('#np-sticky-atc');
    var anchor = qs('[data-np-atc-anchor]');
    if (!bar || !anchor) return;
    window.addEventListener('scroll', function () {
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0);
    }, { passive: true });
  }

  /* ------------------------------------------------------------ koleksiyon araclari */
  function collectionTools() {
    /* izgara sutun degistirici */
    qsa('[data-np-grid]').forEach(function (btn) {
      on(btn, 'click', function () {
        var val = btn.getAttribute('data-np-grid');
        var grid = qs('[data-np-products]');
        if (!grid) return;
        grid.className = 'np-products np-products--' + val;
        qsa('[data-np-grid]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        qsa('.np-card', grid).forEach(function (c) { c.classList.toggle('np-card--list', val === 'list'); });
        try { localStorage.setItem('np_grid', val); } catch (e) {}
      });
    });
    var saved;
    try { saved = localStorage.getItem('np_grid'); } catch (e) {}
    if (saved) {
      var b = qs('[data-np-grid="' + saved + '"]');
      if (b) b.click();
    }

    /* siralama */
    var sort = qs('[data-np-sort]');
    if (sort) {
      on(sort, 'change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }

    /* filtre formu */
    var facetForm = qs('[data-np-facet-form]');
    if (facetForm) {
      on(facetForm, 'change', function (e) {
        if (e.target.matches('input[type=checkbox], input[type=radio]')) facetForm.requestSubmit ? facetForm.requestSubmit() : facetForm.submit();
      });
      qsa('[data-np-facet-price] input', facetForm).forEach(function (inp) {
        on(inp, 'change', function () { facetForm.requestSubmit ? facetForm.requestSubmit() : facetForm.submit(); });
      });
    }

    /* daha fazla yukle / sonsuz kaydirma */
    var more = qs('[data-np-loadmore]');
    if (more && more.getAttribute('data-auto') === '1' && 'IntersectionObserver' in window) {
      var io2 = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !en.target.classList.contains('is-loading')) en.target.click();
        });
      }, { rootMargin: '300px' });
      io2.observe(more);
    }
    if (more) {
      on(more, 'click', function () {
        var url = more.getAttribute('data-url');
        if (!url) return;
        more.classList.add('is-loading');
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-np-products]');
            var grid = qs('[data-np-products]');
            if (newGrid && grid) grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
            var nextBtn = doc.querySelector('[data-np-loadmore]');
            if (nextBtn && nextBtn.getAttribute('data-url')) more.setAttribute('data-url', nextBtn.getAttribute('data-url'));
            else more.remove();
            more.classList.remove('is-loading');
            syncListCounts();
            observeAnim();
          });
      });
    }
  }

  /* ------------------------------------------------------------ bulten acilir */
  function newsletterPopup() {
    var modal = qs('#np-newsletter-popup');
    if (!modal) return;
    var delay = Number(modal.getAttribute('data-delay') || 6) * 1000;
    var days = Number(modal.getAttribute('data-days') || 7);
    var key = 'np_news_seen';
    var seen;
    try { seen = Number(localStorage.getItem(key) || 0); } catch (e) { seen = 0; }
    if (seen && Date.now() - seen < days * 864e5) return;
    setTimeout(function () {
      Modal.open('np-newsletter-popup');
      try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
    }, delay);
  }

  /* ------------------------------------------------------------ kaydirma animasyonu */
  var animObserver;
  function observeAnim() {
    if (!('IntersectionObserver' in window)) { qsa('.np-anim').forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!animObserver) {
      animObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); animObserver.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -40px 0px' });
    }
    qsa('.np-anim:not(.is-in)').forEach(function (el) { animObserver.observe(el); });
  }

  /* ------------------------------------------------------------ kart renk secimi */
  function cardSwatches() {
    on(document, 'click', function (e) {
      var sw = e.target.closest('[data-np-card-swatch]');
      if (!sw) return;
      e.preventDefault();
      var card = sw.closest('.np-card');
      var img = qs('.np-card__img--main', card);
      var src = sw.getAttribute('data-img');
      if (img && src) { img.src = src; img.srcset = ''; }
      qsa('[data-np-card-swatch]', card).forEach(function (s) { s.classList.toggle('is-active', s === sw); });
      var vid = sw.getAttribute('data-variant');
      var form = qs('form[data-np-cart-form]', card);
      if (form && vid) { var i = qs('input[name=id]', form); if (i) i.value = vid; }
    });
  }


  /* ------------------------------------------------------------ lookbook noktalari */
  function hotspots() {
    on(document, 'click', function (e) {
      var dot = e.target.closest('[data-np-hotspot]');
      var open = qsa('.np-look__hotspot.is-open');
      if (!dot) {
        if (!e.target.closest('.np-look__card')) open.forEach(function (h) { h.classList.remove('is-open'); });
        return;
      }
      e.preventDefault();
      var host = dot.closest('.np-look__hotspot');
      open.forEach(function (h) { if (h !== host) h.classList.remove('is-open'); });
      host.classList.toggle('is-open');
    });
  }

  /* ------------------------------------------------------------ video oynat */
  function videoPlay() {
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-np-video-play]');
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.closest('[data-np-video]');
      var url = btn.getAttribute('data-url') || '';
      var embed = '';
      var yt = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([\w-]{6,})/);
      var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (yt) embed = 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0';
      else if (vm) embed = 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
      if (!embed) return;
      wrap.innerHTML = '<div style="position:relative;padding-bottom:56.25%"><iframe src="' + embed +
        '" style="position:absolute;inset:0;width:100%;height:100%" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="video"></iframe></div>';
    });
  }


  /* ------------------------------------------------------------ favori / karsilastirma sayfasi */
  function listPage() {
    var root = qs('[data-np-list-page]');
    if (!root) return;
    var key = root.getAttribute('data-np-list-page') === 'compare' ? 'np_compare' : 'np_wishlist';
    var grid = qs('[data-np-list-grid]', root);
    var empty = qs('[data-np-list-empty]', root);
    var loading = qs('[data-np-list-loading]', root);
    var actions = qs('[data-np-list-actions]', root);
    var handles = store(key);

    function showEmpty() {
      if (grid) grid.hidden = true;
      if (loading) loading.hidden = true;
      if (actions) actions.hidden = true;
      if (empty) empty.hidden = false;
    }

    if (!handles.length) { showEmpty(); return; }
    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '?section_id=np-card-fragment')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (parts) {
      var html = parts.filter(Boolean).map(function (p) {
        var doc = new DOMParser().parseFromString(p, 'text/html');
        var card = doc.querySelector('.np-card');
        return card ? card.outerHTML : '';
      }).filter(Boolean).join('');
      if (loading) loading.hidden = true;
      if (!html) { showEmpty(); return; }
      grid.innerHTML = html;
      grid.hidden = false;
      if (actions) actions.hidden = false;
      syncListCounts();
      observeAnim();
    });

    on(qs('[data-np-list-clear]', root), 'click', function () {
      saveStore(key, []);
      syncListCounts();
      showEmpty();
    });

    /* favoriden cikarinca karti listeden dusur */
    document.addEventListener('np:list:changed', function (e) {
      if (e.detail !== key) return;
      var left = store(key);
      qsa('.np-card', grid).forEach(function (card) {
        var h = card.getAttribute('data-handle');
        if (h && left.indexOf(h) === -1) card.remove();
      });
      if (!qs('.np-card', grid)) showEmpty();
    });
  }

  /* ------------------------------------------------------------ karsilastirma tablosu */
  function comparePage() {
    var root = qs('[data-np-compare-page]');
    if (!root) return;
    var table = qs('[data-np-compare-table]', root);
    var empty = qs('[data-np-compare-empty]', root);
    var loading = qs('[data-np-compare-loading]', root);
    var actions = qs('[data-np-compare-actions]', root);
    var handles = store('np_compare').slice(0, 4);

    function showEmpty() {
      if (table) { table.hidden = true; table.innerHTML = ''; }
      if (loading) loading.hidden = true;
      if (actions) actions.hidden = true;
      if (empty) empty.hidden = false;
    }

    if (!handles.length) { showEmpty(); return; }
    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      if (loading) loading.hidden = true;
      if (!items.length) { showEmpty(); return; }

      var optionNames = [];
      items.forEach(function (p) {
        (p.options || []).forEach(function (o) {
          var name = typeof o === 'string' ? o : o.name;
          if (name && name !== 'Title' && optionNames.indexOf(name) === -1) optionNames.push(name);
        });
      });

      function cellOption(p, name) {
        var idx = -1;
        (p.options || []).forEach(function (o, i) {
          var n = typeof o === 'string' ? o : o.name;
          if (n === name) idx = i;
        });
        if (idx === -1) return '&mdash;';
        var vals = [];
        (p.variants || []).forEach(function (v) {
          var val = v.options ? v.options[idx] : null;
          if (val && vals.indexOf(val) === -1) vals.push(val);
        });
        return vals.length ? esc(vals.join(', ')) : '&mdash;';
      }

      var rows = [
        { label: '', cells: items.map(function (p) {
            var img = p.featured_image || (p.images && p.images[0]);
            return '<a class="np-compare__head" href="' + esc(p.url) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
              '<span class="np-compare__name">' + esc(p.title) + '</span></a>' +
              '<button type="button" class="np-compare__remove" data-np-compare-remove="' + esc(p.handle) + '">' +
              (T.strings.remove || 'Kaldır') + '</button>';
          }) },
        { label: T.strings.priceLabel || 'Fiyat', cells: items.map(function (p) {
            var html = '<span class="np-price__current">' + formatMoney(p.price) + '</span>';
            if (p.compare_at_price && p.compare_at_price > p.price) {
              html += ' <span class="np-price__old">' + formatMoney(p.compare_at_price) + '</span>';
            }
            return '<span class="np-price">' + html + '</span>';
          }) },
        { label: T.strings.availability || 'Durum', cells: items.map(function (p) {
            return p.available
              ? '<span class="np-card__stock" style="display:inline-flex">' + esc(T.strings.inStock || 'Stokta') + '</span>'
              : '<span class="np-text-soft">' + esc(T.strings.soldOut || 'Tükendi') + '</span>';
          }) },
        { label: T.strings.typeLabel || 'Kategori', cells: items.map(function (p) { return esc(p.type || '—'); }) },
        { label: T.strings.vendorLabel || 'Marka', cells: items.map(function (p) { return esc(p.vendor || '—'); }) }
      ];

      optionNames.forEach(function (name) {
        rows.push({ label: esc(name), cells: items.map(function (p) { return cellOption(p, name); }) });
      });

      rows.push({ label: T.strings.descLabel || 'Açıklama', cells: items.map(function (p) {
        var txt = String(p.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        return '<span class="np-compare__desc">' + esc(txt.slice(0, 160)) + (txt.length > 160 ? '…' : '') + '</span>';
      }) });

      rows.push({ label: '', cells: items.map(function (p) {
        return '<a class="np-btn np-btn--sm np-btn--primary" href="' + esc(p.url) + '">' +
          esc(T.strings.viewDetails || 'İncele') + '</a>';
      }) });

      var html = '<table class="np-compare__table"><tbody>';
      rows.forEach(function (r) {
        html += '<tr><th scope="row">' + r.label + '</th>';
        r.cells.forEach(function (c) { html += '<td>' + c + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table>';

      table.innerHTML = html;
      table.hidden = false;
      if (actions) actions.hidden = false;
    });

    on(root, 'click', function (e) {
      var rm = e.target.closest('[data-np-compare-remove]');
      if (rm) {
        var h = rm.getAttribute('data-np-compare-remove');
        saveStore('np_compare', store('np_compare').filter(function (x) { return x !== h; }));
        syncListCounts();
        comparePage();
        return;
      }
      if (e.target.closest('[data-np-compare-clear]')) {
        saveStore('np_compare', []);
        syncListCounts();
        showEmpty();
      }
    });
  }

  /* ------------------------------------------------------------ cerez seridi */
  function cookieBar() {
    var bar = qs('[data-np-cookie]');
    if (!bar) return;
    var days = Number(bar.getAttribute('data-days')) || 180;
    var saved;
    try { saved = Number(localStorage.getItem('np_cookie') || 0); } catch (e) { saved = 0; }
    if (saved && Date.now() - saved < days * 864e5) return;

    setTimeout(function () { bar.hidden = false; bar.classList.add('is-open'); }, 900);
    function dismiss() {
      try { localStorage.setItem('np_cookie', String(Date.now())); } catch (e) {}
      bar.classList.remove('is-open');
      setTimeout(function () { bar.hidden = true; }, 400);
    }
    on(qs('[data-np-cookie-accept]', bar), 'click', dismiss);
    on(qs('[data-np-cookie-decline]', bar), 'click', dismiss);
  }

  /* ------------------------------------------------------------ odak tuzagi (erisilebilirlik) */
  var lastFocused = null;
  function focusTrap() {
    var SEL = 'a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';
    on(document, 'keydown', function (e) {
      if (e.key !== 'Tab') return;
      var open = qs('.np-drawer.is-open') || qs('.np-modal.is-open');
      if (!open) return;
      var items = qsa(SEL, open).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    document.addEventListener('np:overlay:open', function () { lastFocused = document.activeElement; });
    document.addEventListener('np:overlay:close', function () {
      if (lastFocused && lastFocused.focus) { try { lastFocused.focus(); } catch (e) {} }
      lastFocused = null;
    });
  }


  /* ------------------------------------------------------------ sekmeli mega menu */
  function megaTabs() {
    qsa('[data-np-megatabs]').forEach(function (nav) {
      var root = nav.closest('.np-mega');
      if (!root) return;
      qsa('[data-np-megatab]', nav).forEach(function (btn) {
        function activate() {
          var id = btn.getAttribute('data-np-megatab');
          qsa('[data-np-megatab]', nav).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          qsa('[data-np-megapanel]', root).forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-np-megapanel') === id);
          });
        }
        on(btn, 'mouseenter', activate);
        on(btn, 'focus', activate);
        on(btn, 'click', function (e) { e.preventDefault(); activate(); });
      });
    });
  }

  /* ------------------------------------------------------------ indirim kodu */
  function discountField() {
    var wrap = qs('[data-np-discount]');
    if (!wrap) return;
    var input = qs('[data-np-discount-input]', wrap);
    var note = qs('[data-np-discount-note]', wrap);
    on(qs('[data-np-discount-apply]', wrap), 'click', function () {
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      if (note) note.hidden = false;
      window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    });
    on(input, 'keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); qs('[data-np-discount-apply]', wrap).click(); }
    });
  }

  /* ------------------------------------------------------------ baslat */
  function init() {
    bindDrawerTriggers();
    bindCart();
    bindQty();
    stickyHeader();
    announcement();
    miniSelects();
    mobileMenu();
    predictiveSearch();
    slideshows();
    sliders();
    tabs();
    countdowns();
    hoverImages();
    toTop();
    bindLists();
    quickView();
    initVariantPickers(document);
    gallery();
    stickyAtc();
    collectionTools();
    newsletterPopup();
    cardSwatches();
    hotspots();
    videoPlay();
    megaTabs();
    discountField();
    listPage();
    comparePage();
    cookieBar();
    focusTrap();
    observeAnim();
    recentlyViewed();
    if (qs('[data-np-cart-lines]')) Cart.get().catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () {
    slideshows(); sliders(); countdowns(); initVariantPickers(document); gallery(); observeAnim(); syncListCounts();
  });
})();
